import { INTERVIEW_ENTRANCE_TYPES, INTERVIEW_SCHEDULE_TYPES, INTERVIEW_STATES } from "../constants";

export const initInterview = (form = {}) => ({
    ...(form || {}),

    _company: form?._company ?? null,
    _interviewers: [...(form?._interviewers || [])],
    _interviewees: [...(form?._interviewees || [])],
    _participants: [...(form?._participants || [])],

    title: form?.title ?? null,
    state: form?.state ?? INTERVIEW_STATES.AWAITING.value,

    entrance: {
        ...(form?.entrance || {}),
        type: form?.entrance?.type ?? INTERVIEW_ENTRANCE_TYPES.ONE_WITH_URL.value,
        disabled: form?.entrance?.disabled ?? false,
        meta: {
            ...(form?.entrance?.meta || {}),
            message: form?.entrance?.meta?.message ?? null,
            disabled: form?.entrance?.meta?.disabled ?? false,
        },
    },

    schedule: {
        ...(form?.schedule || {}),

        type: form?.schedule?.type ?? INTERVIEW_SCHEDULE_TYPES.INSTANT.value,

        at: form?.schedule?.at ?? null,
        date: form?.schedule?.date ?? Date.now().toDate(),
        hour: form?.schedule?.hour ?? 10,
        minute: form?.schedule?.minute ?? 0,
    },
});
